<template lang="html">
  <v-container fluid class="px-sm-10">
    <v-row>
      <v-col>

        <base-items store-module="audits" :filter="auditFilter" @items="items = $event" @state="state = $event" />
        <base-items store-module="publications" :filter="auditFilter" @items="publications = $event" @state="publicationsState = $event" />
        <base-items store-module="categories" @items="categories = $event" />
        <base-items store-module="itemgroups" @items="itemgroups = $event" />
        <base-items store-module="messages" @items="messages = $event" />
        <base-items store-module="operators" @items="operators = $event" />
        <base-items store-module="overviews" @items="overviews = $event" />
        <base-items store-module="products" @items="products = $event" />
        <base-items store-module="sideorders" @items="sideorders = $event" />
        <base-items store-module="tabs" @items="tabs = $event" />

        <v-card :loading="state.loading || publicationsState.loading">
          <v-card-title>
            <v-row align="center">
              <v-col cols="auto" class="headline">
                Audit log
              </v-col>
              <v-spacer/>
              <v-col>
                <v-checkbox
                  class="body-2 mt-0"
                  label="Fetch all log entries"
                  v-model="fetchAllEntries"
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <div class="mb-3">
              <p>
                This log tracks all changes made in the admin interface.
              </p>
              <p v-if="fetchAllEntries">
                Inlcudes all log entries
              </p>
              <p v-else>
                Inlcudes log entries for the last week
              </p>
            </div>
            <p v-if="sortedItems.length == 0">
              No entries
            </p>
            <div v-else>
              <v-expansion-panels>
                <v-expansion-panel
                  v-for="item in sortedItems"
                  :key="item.id"
                >
                  <template v-if="item.publication">
                    <v-expansion-panel-header>
                      <v-row dense>
                        <v-col cols="6" sm="3">
                          <span class="font-weight-bold">Publication</span>
                        </v-col>
                        <v-spacer/>
                        <v-col cols="6" sm="3">
                          <span>{{item.created_at}}</span>
                        </v-col>
                        <v-col cols="6" sm="3">
                          <span>{{item.created_by}}</span>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <info-table
                        :headers="publicationHeaders"
                        :value="item"
                      ></info-table>
                    </v-expansion-panel-content>
                  </template>

                  <template v-else>
                    <v-expansion-panel-header>
                      <v-row dense>
                        <v-col cols="6" sm="3">
                          <span>{{item.action}} {{item.type_name}}</span>
                        </v-col>
                        <v-col cols="6" sm="3">
                          <span>{{item.identifier}}</span>
                        </v-col>
                        <v-spacer/>
                        <v-col cols="6" sm="3">
                          <span>{{item.created_at}}</span>
                        </v-col>
                        <v-col cols="6" sm="3">
                          <span>{{item.created_by}}</span>
                        </v-col>
                      </v-row>

                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <info-table
                        :headers="auditHeaders"
                        :value="item"
                      ></info-table>

                      <div v-if="item.action == 'Updated'" class="mt-4">
                        <h3 class="text--secondary">Changes</h3>
                        <info-table
                          v-for="change in item.data"
                          :key="change.key"
                          :headers="change.key == 'attachment' ? attachmentChangeHeaders : changeHeaders"
                          :value="change"
                          class="mb-4"
                        ></info-table>
                      </div>
                      <div v-else class="mt-4">
                        <h3 class="text--secondary">Item Data</h3>
                        <info-table
                          :headers="getDataHeaders(item.data)"
                          :value="item.data"
                        ></info-table>
                      </div>
                    </v-expansion-panel-content>
                  </template>
                </v-expansion-panel>
              </v-expansion-panels>

            </div>
          </v-card-text>
        </v-card>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {getItemById} from '@dynapp/wc-api-generic';
import {BaseItems} from 'dync-baseitem';
import InfoTable from '../components/InfoTable.vue';
import moment from 'moment-timezone'


var capitalizeFirstLetter = (string) => {
  string = string || '';
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export default {
  name: 'Auditlog',
  data () {
    return {
      fetchAllEntries: false,
      items: [],
      state: {},
      publications: [],
      publicationsState: {},
      publicationHeaders: [
        {
          text: 'Created at',
          value: 'created_at'
        },
        {
          text: 'Created by',
          value: 'created_by'
        },
        {
          text: 'Id',
          value: 'id'
        }
      ],
      auditHeaders: [
        {
          text: 'Action',
          value: 'action'
        },
        {
          text: 'Item type',
          value: 'type_name'
        },
        {
          text: 'Item identifier',
          value: 'identifier'
        },
        {
          text: 'Performed at',
          value: 'created_at'
        },
        {
          text: 'Performed by',
          value: 'created_by'
        },
        {
          text: 'Item Data type',
          value: 'item_type'
        },
        {
          text: 'Item Id',
          value: 'item_id'
        },
        {
          text: 'Audit Id',
          value: 'id'
        }
      ],
      changeHeaders: [
        {
          text: 'Property',
          value: 'key'
        },
        {
          text: 'Old value',
          value: 'old_value',
          morph: this.changesMorph
        },
        {
          text: 'New value',
          value: 'new_value',
          morph: this.changesMorph
        }
      ],
      attachmentChangeHeaders: [
        {
          text: 'Attachment',
          value: 'attachment'
        },
        {
          text: 'Change',
          value: 'change'
        }
      ],
      categories: [],
      itemgroups: [],
      messages: [],
      operators: [],
      overviews: [],
      products: [],
      sideorders: [],
      tabs: []
    };
  },
  computed: {
    sortedItems() {
      var items = this.items.slice(0);
      items = items.concat(this.publications.map(item => ({...item, publication: true})));
      items.sort((a, b) => {
        if (a.created_at > b.created_at) {
          return -1;
        } else if (a.created_at < b.created_at) {
          return 1;
        }
        return 0;
      });
      return items;
    },
    auditFilter() {
      if (this.fetchAllEntries) {
        return undefined;
      }
      return {
        greaterThan: [
          ['created_at', moment().subtract(1, 'week').tz('Europe/Stockholm').format('YYYY-MM-DD HH:mm:ss')]
        ]
      };
    }
  },
  methods: {
    lookup_display_value(items, id, key='name') {
      var item = getItemById(items, id);
      if (item == null) {
        return id;
      }
      return item[key];
    },
    lookup_display_values(items, ids, key='name') {
      return (ids || []).map(id => this.lookup_display_value(items, id, key))
    },
    changesMorph(value, key, item) {
      return this.morphdata(value, item.key);
    },
    morphdata(value, key) {
      var display_value = null;
      var item;

      if (key == 'category') {
        display_value = this.lookup_display_value(this.categories, value, 'title');
      } else if (key == 'itemgroup') {
        item = getItemById(this.itemgroups, value)
        if (item) {
          display_value = `${item.name} ${item.vat}%`;
        }
      } else if (key == 'operator_id') {
        display_value = this.lookup_display_value(this.operators, value, 'name');
      } else if (key == 'sideorders') {
        display_value = this.lookup_display_values(this.sideorders, value, 'name');
      } else if (key == 'itemgroupIds') {
        display_value = this.lookup_display_values(this.itemgroups, value, 'name');
      }

      if (display_value && Array.isArray(display_value)) {
        display_value = display_value.join(', ')
      } else if (Array.isArray(value)) {
        display_value = value.join(', ')
      }
      if (display_value) {
        return display_value;
      }
      return value;
    },
    getDataHeaders(item) {
      return Object.keys(item).sort().map((key) => {
        return {
          text: capitalizeFirstLetter(key),
          value: key,
          morph: this.morphdata
        };
      });
    }
  },
  components: {
    BaseItems,
    InfoTable
  }
}
</script>

<style lang="scss" scoped>
.handle {
  cursor: grab;
}
</style>
